import { FooterMenu, HeaderMenu } from "components"
import { useSearchParams } from "react-router-dom"
import { ItemsAdjustment } from "./ItemAdjustment"
import { RegisterItemsBuild } from "./ItemBuild/RegisterItemsBuild"
import { ItemsCount } from "./ItemCount"
import { ItemsGroup } from "./ItemGroup"
import { ItemsReceived } from "./ItemReceived"
import { ItemsTransfer } from "./ItemTransfer"
import { TabNavRegister } from "./TabNavRegister"
import { TabRegisterPath } from "./types"
import { RequestForm } from "./RequestForm"
import { DataProvider } from "./utils/contexts"
import { useContext, useState } from "react"
import { ModalExportItemGroup } from "./ItemGroup/components"
import { ModalExportTransfer } from "./ItemTransfer/components"
import { ModalExportReceived } from "./ItemReceived/components"
import { ModalExportAdjusment } from "./ItemAdjustment/components"
import { ModalExportCount } from "./ItemCount/components"
import { ModalExportBuild } from "./ItemBuild/components"
import { ModalExportRequestForm } from "./RequestForm/components"
import { AuthContext } from "contexts"
import { PERMISION } from "security"

type TabsSearchParams = {
  tabs: TabRegisterPath
}


export default function InventoriRegister() {
  const { permission: list } = useContext(AuthContext)
  const [searchParams, setSearchParams] = useSearchParams({ tabs: Boolean(list.find((val) => val.startsWith(PERMISION.INVENTORY.REGISTER.REGISTER_GROUP.PERMISION))) ? "items-group" : "" } as TabsSearchParams) 
  const activeTab = searchParams.get("tabs")
  const setActiveTab = (path: string) => setSearchParams({ tabs: path })

  return (
    <DataProvider>
      <section className="container my-5">
        <HeaderMenu title="INVENTORY REGISTER" className="sticky top-[32px] z-[1]" />
        <TabNavRegister activeTab={activeTab!} setActiveTab={setActiveTab} />
        {activeTab === "items-group" && <ItemsGroup />}
        {activeTab === "items-transfer" && <ItemsTransfer />}
        {activeTab === "items-adjustment" && <ItemsAdjustment />}
        {activeTab === "items-count" && <ItemsCount />}
        {activeTab === "items-build" && <RegisterItemsBuild />}
        {activeTab === "items-received" && <ItemsReceived />}
        {activeTab === "items-proces" && <RequestForm />}

        <Footer activeTab={activeTab} />
      </section>
    </DataProvider>
  )
}

function Footer(props: { activeTab: string | null }) {

  const [isOpenModal, setIsOpenModal] = useState<{ isOpen: boolean; type: "excel" | "pdf" | string, activeTab: string | null }>({
    isOpen: false,
    type: "",
    activeTab: props.activeTab
  })

  return (
    <>
      <FooterMenu
        export={{
          actiontype: "export",
          onClick: () => setIsOpenModal({
            isOpen: true,
            type: "excel",
            activeTab: props.activeTab
          })
        }}

        pdf={{
          actiontype: "pdf",
          onClick: () => setIsOpenModal({
            isOpen: true,
            type: "pdf",
            activeTab: props.activeTab
          })
        }}
      />

      {isOpenModal.isOpen && isOpenModal.activeTab === "items-group" &&
        <ModalExportItemGroup
          setIsOpen={setIsOpenModal}
          type={isOpenModal.type}
        />
      }

      {isOpenModal.isOpen && isOpenModal.activeTab === "items-transfer" &&
        <ModalExportTransfer
          setIsOpen={setIsOpenModal}
          type={isOpenModal.type}
        />
      }

      {isOpenModal.isOpen && isOpenModal.activeTab === "items-received" &&
        <ModalExportReceived
          setIsOpen={setIsOpenModal}
          type={isOpenModal.type}
        />
      }

      {isOpenModal.isOpen && isOpenModal.activeTab === "items-count" &&
        <ModalExportCount
          setIsOpen={setIsOpenModal}
          type={isOpenModal.type}
        />
      }

      {isOpenModal.isOpen && isOpenModal.activeTab === "items-adjustment" &&
        <ModalExportAdjusment
          setIsOpen={setIsOpenModal}
          type={isOpenModal.type}
        />
      }

      {isOpenModal.isOpen && isOpenModal.activeTab === "items-build" &&
        <ModalExportBuild
          setIsOpen={setIsOpenModal}
          type={isOpenModal.type}
        />
      }

      {isOpenModal.isOpen && isOpenModal.activeTab === "items-proces" &&
        <ModalExportRequestForm
          setIsOpen={setIsOpenModal}
          type={isOpenModal.type}
        />
      }

    </>
  )
}


